/**
 * Fire a `Viewed` analytics event once per mounted instance.
 *
 * The ref guard, not the empty deps, is what enforces "once": StrictMode re-runs
 * mount effects on the same fiber in dev, so without it every view double-counts.
 * A genuine remount gets a fresh ref and does re-emit, which is intended.
 * Re-emitting therefore requires a real remount, not a visibility toggle.
 */

import { useEffect, useRef } from "react";
import { trackViewed, type ViewedElementType, type ViewedProps } from "./events";

export function usePageView(elementName: string, elementType: ViewedElementType, props: ViewedProps): void {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    trackViewed(elementName, elementType, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
